module.exports = __webpack_public_path__ + "img/instagram.07edc562.png";